<div
  class="footer-block"
  [class.footer-block--mobile]="showMobileFooter()"
  *transloco="let t"
>
  @if (showMobileFooter()) {
    <div class="footer-block__mobile" dataAttribute componentName="footer-mobile">
      @if (footerMobileComponent(); as footerMobileComponent) {
        <ng-container *ngComponentOutlet="footerMobileComponent; inputs: { menu: menu }" />
      }
    </div>
  } @else {
    @if (canUseTabletColumnsLayout) {
      <div
        class="footer-block__wrapper footer-block__wrapper--tablet-columns"
        *showOnPlatform="Platform.Tablet"
      >
        <div class="footer-block__column">
          <div class="footer-block__info brand-contacts">
            <b2b-brand-contacts></b2b-brand-contacts>
          </div>

          <div class="footer-block__info">
            <b2b-footer-menu-column
              [column]="menu[0]"
              [index]="0"
            ></b2b-footer-menu-column>
          </div>
        </div>

        <div class="footer-block__column">
          <ng-container [ngTemplateOutlet]="payment"></ng-container>

          <div class="footer-block__info">
            <b2b-footer-menu-column
              [column]="menu[1]"
              [index]="1"
            ></b2b-footer-menu-column>
          </div>
        </div>
      </div>
    }

    @if (canUseTabletColumnsLayout) {
      <div
        class="footer-block__wrapper"
        *showOnPlatform="[Platform.Mobile, Platform.Desktop]"
      >
        <ng-container [ngTemplateOutlet]="defaultContent"></ng-container>
      </div>
    } @else {
      <div class="footer-block__wrapper">
        <ng-container [ngTemplateOutlet]="defaultContent"></ng-container>
      </div>
    }
  }
</div>

<ng-template #defaultContent>
  <div class="footer-block__info brand-contacts">
    <b2b-brand-contacts></b2b-brand-contacts>
  </div>

  <ng-container
    *showOnPlatform="Platform.Tablet"
    [ngTemplateOutlet]="payment"
  ></ng-container>

  @for (column of menu; track column; let index = $index) {
    <div class="footer-block__info">
      <b2b-footer-menu-column
        [column]="column"
        [index]="index"
      ></b2b-footer-menu-column>
    </div>
  }

  <ng-container
    *showOnPlatform="[Platform.Mobile, Platform.Desktop]"
    [ngTemplateOutlet]="payment"
  ></ng-container>
</ng-template>

<ng-template #payment>
  <div
    class="footer-block__info"
    *showContentFor="BuildTypesEnum.ru"
    dataAttribute
    componentName="footer-info-payment"
  >
    <b2b-footer-payment></b2b-footer-payment>
  </div>

  <ng-container *showContentFor="BuildTypesEnum.tr">
    @if (paymentTRComponent(); as paymentComponent) {
      <ng-container *ngComponentOutlet="paymentComponent" />
    }
  </ng-container>
</ng-template>
